import {AxiosResponse} from 'axios';
import {axiosInstance} from '..';

export function getSubtypes(): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`Subtypes/List`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}